import SubscriptionOptionFull from './components/SubscriptionOptionFull';
import { Option } from 'owa-options-core';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getUserConfiguration } from 'owa-session-store';

let SubscriptionOption: Option = {
    key: 'subscription',
    titleStringKey: 'optionTitle_premium_subscription',
    searchTermsStringKey: 'optionTitle_premium_subscription',
    fullOptionFormSettings: {
        render: () => <SubscriptionOptionFull />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: () =>
        isFeatureEnabled('auth-PremiumDashboardApril') ||
        !isFeatureEnabled('auth-PremiumDashboard') ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
};

let SubscriptionOptionApril: Option = {
    key: 'subscription_',
    titleStringKey: 'optionTitle_premium_subscription',
    searchTermsStringKey: 'optionTitle_premium_subscription',
    fullOptionFormSettings: {
        render: () => <SubscriptionOptionFull />,
        isDirty: () => false,
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: () => true,
    },
    isHidden: () =>
        !isFeatureEnabled('auth-PremiumDashboardApril') ||
        !getUserConfiguration().SessionSettings.IsPremiumConsumerMailbox,
};

export default SubscriptionOption;
export { SubscriptionOptionApril };
